/**
 * Legacy: Smoothscroll
 *
 * @module legacy/LSmoothscroll
 */


// Dependances
// ============================================================================

import { $ } from '../common/utility/u-jquery-$';


// ƒs
// ============================================================================

/**
 * Core module init
 *
 * @return  {void}
 */
function _moduleInit()
{
	$('a[href*="#"]')
		// Remove links that don't actually link to anything
	.not('[href="#"]')
	.not('[href^="#page-container"]')
	.not('.faq-content a[href*="#"]')
	.not('.playbook-menu a[href*="#"]')
	.not('.logo-tab a[href*="#"]')
	.not('.module-hero__buttons a[href*="#driftpricingplatform"]')
	.not('[href="#0"]').click(function(event) {
		if (
			location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
			location.hostname == this.hostname
		) {
			// Figure out element to scroll to
			var target = $(this.hash);

			// Use the header height for the offset
			var offset = $('.v3-header').outerHeight(true);

			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

			// Does a scroll target exist?
			if (target.length) {
				// Only prevent default if animation is actually gonna happen
				event.preventDefault();

				// Is target a v3 form?
				if (target.hasClass('v3-form'))
				{
					offset += 60; // 60 represents the additional outer container padding required
				}

				$('html, body').animate({
					scrollTop: target.offset().top - offset
				}, 1000);
			}
		}
	});
}

/**
 * Core module load
 *
 * @return  {void}
 */
function _moduleLoad()
{
	if (window.location.hash.length) {
		// Figure out element to scroll to
		var target = $(window.location.hash);

		// Use the header height for the offset
		var offset = $('.v3-header').outerHeight(true);

		target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
		console.log(offset);

		// Does a scroll target exist?
		if (target.length) {
			// Is target a v3 form?
			if (target.hasClass('v3-form'))
			{
				offset += 60; // 60 represents the additional outer container padding required
				console.log('form offset increased: ', offset);
			}

			console.log(target);


			$('html, body').animate({
				scrollTop: target.offset().top - offset
			}, 1000);
		}
	}
}

// Auto Init
// ============================================================================

$( document ).ready( () => _moduleInit() );

$( window ).on( 'load', () => {
	setTimeout(_moduleLoad, 300);
});
